import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";

/**
 * The run's human-facing identifier ("Payroll ID" in the UI): its
 * `payrollNumber`, falling back to the id for runs the API has not numbered.
 */
export const selectorPayrollRunNumber = (payrollRun: PayrollRun): string =>
  payrollRun.payrollNumber ?? payrollRun.id ?? "";
